import {html} from "lit";

export default function (level: string, text: string, classes: string[] = [], partName = 'heading') {
  let headingClass = '';
  if (classes.length) {
    headingClass = classes.join(' ');
  }
  if (level === 'h1') {
    return html`<h1 class=${headingClass} part=${partName}>${text}</h1>`;
  } else if (level === 'h2') {
    return html`<h2 class=${headingClass} part=${partName}>${text}</h2>`;
  } else if (level === 'h3') {
    return html`<h3 class=${headingClass} part=${partName}>${text}</h3>`;
  } else if (level === 'h4') {
    return html`<h4 class=${headingClass} part=${partName}>${text}</h4>`;
  } else if (level === 'h5') {
    return html`<h5 class=${headingClass} part=${partName}>${text}</h5>`;
  } else if (level === 'h6') {
    return html`<h6 class=${headingClass} part=${partName}>${text}</h6>`;
  } else if (level === 'p') {
    return html`<p class=${headingClass} part=${partName}>${text}</p>`;
  } else {
    return html`<h3 class=${headingClass} part=${partName}>${text}</h3>`;
  }
}
